module.exports = __webpack_public_path__ + "static/banner_partners-a7a6bf4e2b97bfe2d393e4e3473363a0.png";